// Privacy-aware SaturnRings conversion events.
// Events contain product/interaction metadata only; personalized name text is never sent.
(function () {
  'use strict';

  function analyticsAllowed() {
    try {
      if (
        window.Shopify &&
        window.Shopify.customerPrivacy &&
        typeof window.Shopify.customerPrivacy.analyticsProcessingAllowed === 'function'
      ) {
        return window.Shopify.customerPrivacy.analyticsProcessingAllowed();
      }
    } catch (error) {}
    // Stay privacy-safe while Shopify's consent API is unavailable or still loading.
    return false;
  }

  function cleanPayload(payload) {
    var output = {};
    Object.keys(payload || {}).forEach(function (key) {
      var value = payload[key];
      if (value === undefined || value === null || value === '') return;
      if (typeof value === 'string') value = value.slice(0, 180);
      output[key] = value;
    });
    return output;
  }

  function track(eventName, payload) {
    if (!eventName) return;

    var detail = cleanPayload(Object.assign({
      page_type: document.body && document.body.dataset ? document.body.dataset.pageType : '',
      path: window.location.pathname
    }, payload || {}));

    document.dispatchEvent(new CustomEvent('saturnrings:' + eventName, { detail: detail }));
    if (!analyticsAllowed()) return;

    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish('saturnrings_' + eventName, detail);
      }
    } catch (error) {}

    if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push(Object.assign({ event: 'saturnrings_' + eventName }, detail));
    }
  }

  window.SaturnRingsAnalytics = { track: track };
  document.documentElement.setAttribute('data-sr-analytics', 'ready');

  document.addEventListener('click', function (event) {
    var link = event.target && event.target.closest ? event.target.closest('[data-sr-track]') : null;
    if (!link) return;
    track(link.getAttribute('data-sr-track'), {
      link_url: link.getAttribute('href') || '',
      link_label: (link.textContent || '').replace(/\s+/g, ' ').trim()
    });
  });

  function observeConversionPrompts() {
    if (!('IntersectionObserver' in window)) return;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var target = entry.target;
        track(target.getAttribute('data-sr-observe'), {});
        observer.unobserve(target);
      });
    }, { threshold: 0.55 });

    document.querySelectorAll('[data-sr-observe]').forEach(function (element) {
      observer.observe(element);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeConversionPrompts, { once: true });
  } else {
    observeConversionPrompts();
  }
})();
